import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IdentityService } from '../../api/services/identity.service';
import { ToastService } from '../../services/toast.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-two-factor',
  templateUrl: './two-factor.component.html',
  standalone: false,
})
export class TwoFactorComponent implements OnInit {
  shouldPromptEmailVerification: boolean = false;
  settingUp = true;
  /**
   * The URL of the QR code the user can scan to set up 2FA
   */
  qrCodeUrl: string | undefined;
  /**
   * The manual entry code the user can enter to setup 2FA, if they cannot scan the QR code
   */
  manualEntryCode: string | undefined;
  /**
   * The form used to enable 2FA, which requires the 2FA code, ensuring the user has properly set up the codes
   * in their authenticator app. This is to ensure a user can't enable 2FA without properly setting it up
   */
  enableTwoFactorForm = new FormGroup({
    twoFactorCode: new FormControl('', [Validators.required]),
  });

  constructor(
    private identityService: IdentityService,
    private toastService: ToastService,
    private authService: AuthService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.shouldPromptEmailVerification =
      window.history.state.shouldPromptEmailVerification ?? false;

    // Initialise 2FA for user, to get the QR code and manual entry code
    this.identityService
      .initialise2faPost$Response(this.authService.getAuthorisationHeaders())
      .subscribe({
        next: (res) => {
          const authenticator = res.body;
          this.qrCodeUrl = authenticator.imageUrl;
          this.manualEntryCode = authenticator.manualEntryCode;
        },
        error: () => {
          this.toastService.error('Could Not Initialise 2FA');
        },
      });
  }

  finishSetup() {
    this.settingUp = false;
  }

  enableTwoFactor() {
    this.identityService
      .enable2faPost$Response(this.authService.getAuthorisationHeaders(), {
        body: {
          code: this.enableTwoFactorForm.controls.twoFactorCode.value!,
        },
      })
      .subscribe({
        next: () => {
          void this.toastService.success('Successfully Enabled 2FA');

          if (this.shouldPromptEmailVerification) {
            // If email verification also required, go to setup page before going home
            void this.router.navigate(['admin/setup-email-verification'], {
              state: { userGuid: window.history.state.userGuid! },
            });
          } else {
            void this.router.navigate(['admin/home']);
          }
        },
        error: () => {
          void this.toastService.error('Could Not Enable 2FA');
        },
      });
  }
}
